import Api from '../../api/api'
import Socket from '../../api/socket'

let changeSubscription = null;

export default {
  namespaced: true,
  state: {
    vote: false, // index of voted tack
    voteId: false, // mpg vote id
    hasWon: false, // voted for the winning song
    running: false, // program has mgp running
    tracks: [], // tracks to vote for or the winning track
  },
  actions: {
    subscribeOnChange({ commit }, payload) {
      if (changeSubscription) {
        changeSubscription.unsubscribe();
      }
      changeSubscription = Socket.subscribe('mgp', 'change', (data) => {
        commit('MGP_DATA', data);
      }, { backlog: 1, ...payload });
    },

    vote({ commit }, { id, index, voteId }) {
      commit('MGP_VOTED', { id, index, voteId });
      Api.post(`/2.0/mgp/votes`, {song_id: id});
      // @TODO add analytics
      // dispatch('radioplayer/analytics', { type: 'vote', payload: state.tracks[index] }, { root: true });
    }
  },
  mutations: {
    MGP_DATA(state, data){
      const hasWinner = data.won_idx !== null;
      state.running = data.running;
      state.tracks = data.songs;
      state.hasWinner = hasWinner;
      state.wonIndex = data.won_idx;

      if (state.voteId !== data.id) {
        state.vote = false;
        state.voteId = data.id;
      } else {
        state.hasWon = hasWinner && state.vote === data.won_idx;
        state.allowVote = !hasWinner && state.vote === false;
      }
    },
    MGP_VOTED(state, data){
      state.vote = data.index;
      state.voteId = data.voteId;
      state.allowVote = false;
    },
  }
}
